import React from 'react';

const CirclePlus: React.FC<React.SVGProps<SVGSVGElement>> = (props) => (
  <svg
    height="20"
    fill="none"
    viewBox="0 0 20 20"
    width="20"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path d={`M10.418 1.51074C11.3914 1.55867 12.3506 1.7737 13.2529
      2.14746C14.2841 2.57462 15.2215 3.20003 16.0107 3.98926C16.8 4.77849
      17.4254 5.7159 17.8525 6.74707C18.2797 7.77834 18.5 8.88376 18.5
      10L18.4893 10.418C18.4413 11.3914 18.2263 12.3506 17.8525 13.2529C17.4254
      14.2841 16.8 15.2215 16.0107 16.0107C15.2215 16.8 14.2841 17.4254 13.2529
      17.8525C12.3506 18.2263 11.3914 18.4413 10.418 18.4893L10 18.5C8.88376 18.5
      7.77834 18.2797 6.74707 17.8525C5.7159 17.4254 4.77849 16.8 3.98926
      16.0107C3.20003 15.2215 2.57462 14.2841 2.14746 13.2529C1.7737 12.3506
      1.55867 11.3914 1.51074 10.418L1.5 10C1.5 8.88376 1.7203 7.77834 2.14746
      6.74707C2.57462 5.7159 3.20003 4.77849 3.98926 3.98926C4.77849 3.20003
      5.7159 2.57462 6.74707 2.14746C7.77834 1.7203 8.88376 1.5 10 1.5L10.418
      1.51074ZM10 3.5C9.14641 3.5 8.30131 3.66846 7.5127 3.99512C6.72408 4.32177
      6.0069 4.79974 5.40332 5.40332C4.79974 6.0069 4.32177 6.72408 3.99512
      7.5127C3.66846 8.30131 3.5 9.14641 3.5 10L3.50781 10.3193C3.54443 11.0638
      3.70926 11.7972 3.99512 12.4873C4.32177 13.2759 4.79974 13.9931 5.40332
      14.5967C6.0069 15.2003 6.72408 15.6782 7.5127 16.0049C8.30131 16.3315
      9.14641 16.5 10 16.5L10.3193 16.4922C11.0638 16.4556 11.7972 16.2907 12.4873
      16.0049C13.2759 15.6782 13.9931 15.2003 14.5967 14.5967C15.2003 13.9931
      15.6782 13.2759 16.0049 12.4873C16.3315 11.6987 16.5 10.8536 16.5 10L16.4922
      9.68066C16.4556 8.93616 16.2907 8.20282 16.0049 7.5127C15.6782 6.72408
      15.2003 6.0069 14.5967 5.40332C13.9931 4.79974 13.2759 4.32177 12.4873
      3.99512C11.7972 3.70926 11.0638 3.54443 10.3193 3.50781L10 3.5ZM10
      6.5C10.5523 6.5 11 6.94772 11 7.5V9H12.5L12.6025 9.00488C13.1067 9.05621
      13.5 9.48232 13.5 10C13.5 10.5177 13.1067 10.9438 12.6025 10.9951L12.5
      11H11V12.5C11 13.0523 10.5523 13.5 10 13.5C9.44772 13.5 9 13.0523 9
      12.5V11H7.5C6.94772 11 6.5 10.5523 6.5 10C6.5 9.44772 6.94772 9 7.5 9H9V7.5C9
      6.94772 9.44772 6.5 10 6.5Z`} fill="#528BFF"/>
  </svg>
);

export default CirclePlus;
